
import { ScheduleItem } from '@/integrations/supabase/client';

export const breaks: ScheduleItem[] = [
  {
    id: "5",
    day: "day1",
    start_time: "10:20",
    end_time: "10:50",
    title: "Networking and Tea Break",
    description: null,
    location: "Networking Area",
    type: "Break",
    speaker: null
  },
  {
    id: "9",
    day: "day1",
    start_time: "12:30",
    end_time: "13:30",
    title: "Lunch Break with Networking",
    description: null,
    location: "Dining Area",
    type: "Break",
    speaker: null
  },
  {
    id: "14",
    day: "day1",
    start_time: "14:30",
    end_time: "15:00",
    title: "Networking Break with Tea/Coffee",
    description: null,
    location: "Networking Area",
    type: "Break",
    speaker: null
  }
];
